export default __webpack_public_path__ + "static/media/for_dopostavka.27baf084.png";